export default "<div class=\"mvta-loading\" [hidden]=\"!_indicator\">\n    <div class=\"mvta-loading-indicator\">\n        <span></span>\n    </div>\n</div>\n"